import { getFormatMixins, isTypedFieldDef, isValueDef } from '../../../channeldef';
import { isSignalRef } from '../../../vega.schema';
import { formatSignalRef } from '../../format';
import { wrapCondition } from './conditional';
export function text(model, channel = 'text') {
    const channelDef = model.encoding[channel];
    return wrapCondition(model, channelDef, channel, cDef => textRef(cDef, model.config));
}
export function textRef(channelDef, config, expr = 'datum') {
    // text
    if (channelDef) {
        if (isValueDef(channelDef)) {
            return { value: channelDef.value };
        }
        if (isTypedFieldDef(channelDef)) {
            const { format, formatType } = getFormatMixins(channelDef);
            return formatSignalRef({ fieldOrDatumDef: channelDef, format, formatType, expr, config });
        }
        if (isSignalRef(channelDef)) {
            return channelDef;
        }
    }
    return undefined;
}
//# sourceMappingURL=text.js.map